// extracted by mini-css-extract-plugin
module.exports = {"iconCell":"postsGrid_iconCell__3dr6f"};